/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { get } from 'lodash';

export const resolveTemplateValue = (context, path) => {
  const nested = get(context, path);

  if (nested !== undefined && nested !== null) {
    return nested;
  }

  if (Object.prototype.hasOwnProperty.call(context, path)) {
    return context[path];
  }

  return '';
};
